import { injectIntl } from "react-intl";
const WithIntl = ({ children, intl }) => {
    return children(intl);
};
export default injectIntl(WithIntl);



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/WithIntl/WithIntl.tsx